// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-edge {
  pointer-events: stroke;
  cursor: pointer;
}

.edge-path {
  transition: all 0.3s ease;
  pointer-events: stroke;
  stroke-linecap: round;
}

.edge-path:hover {
  stroke-width: 3;
  opacity: 0.8;
}

.edge-path.highlighted {
  stroke: #4A90E2;
  stroke-width: 3;
  opacity: 1;
  filter: drop-shadow(0 0 4px rgba(74, 144, 226, 0.6));
  animation: edgePulse 1.5s ease-in-out infinite;
}

/* Persistent highlight - stays active until next update */
.edge-path.persistent-highlight {
  stroke: #4A90E2 !important;
  stroke-width: 5 !important;
  opacity: 1 !important;
  filter: 
    drop-shadow(0 0 8px rgba(74, 144, 226, 1))
    drop-shadow(0 0 12px rgba(74, 144, 226, 0.6));
  animation: persistentPulse 0.8s ease-in-out infinite;
  z-index: 15;
}

@keyframes persistentPulse {
  0%, 100% {
    stroke-width: 5;
    filter: 
      drop-shadow(0 0 8px rgba(74, 144, 226, 1))
      drop-shadow(0 0 12px rgba(74, 144, 226, 0.6));
  }
  50% {
    stroke-width: 6;
    filter: 
      drop-shadow(0 0 12px rgba(74, 144, 226, 1))
      drop-shadow(0 0 18px rgba(74, 144, 226, 0.8));
  }
}

@keyframes edgePulse {
  0%, 100% {
    stroke-width: 3;
    opacity: 1;
  }
  50% {
    stroke-width: 4;
    opacity: 0.9;
  }
}

.edge-label {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
}

`, "",{"version":3,"sources":["webpack://./src/graph_components/GraphEdge.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA,0DAA0D;AAC1D;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB;;iDAE+C;EAC/C,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf;;mDAE+C;EACjD;EACA;IACE,eAAe;IACf;;mDAE+C;EACjD;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".graph-edge {\n  pointer-events: stroke;\n  cursor: pointer;\n}\n\n.edge-path {\n  transition: all 0.3s ease;\n  pointer-events: stroke;\n  stroke-linecap: round;\n}\n\n.edge-path:hover {\n  stroke-width: 3;\n  opacity: 0.8;\n}\n\n.edge-path.highlighted {\n  stroke: #4A90E2;\n  stroke-width: 3;\n  opacity: 1;\n  filter: drop-shadow(0 0 4px rgba(74, 144, 226, 0.6));\n  animation: edgePulse 1.5s ease-in-out infinite;\n}\n\n/* Persistent highlight - stays active until next update */\n.edge-path.persistent-highlight {\n  stroke: #4A90E2 !important;\n  stroke-width: 5 !important;\n  opacity: 1 !important;\n  filter: \n    drop-shadow(0 0 8px rgba(74, 144, 226, 1))\n    drop-shadow(0 0 12px rgba(74, 144, 226, 0.6));\n  animation: persistentPulse 0.8s ease-in-out infinite;\n  z-index: 15;\n}\n\n@keyframes persistentPulse {\n  0%, 100% {\n    stroke-width: 5;\n    filter: \n      drop-shadow(0 0 8px rgba(74, 144, 226, 1))\n      drop-shadow(0 0 12px rgba(74, 144, 226, 0.6));\n  }\n  50% {\n    stroke-width: 6;\n    filter: \n      drop-shadow(0 0 12px rgba(74, 144, 226, 1))\n      drop-shadow(0 0 18px rgba(74, 144, 226, 0.8));\n  }\n}\n\n@keyframes edgePulse {\n  0%, 100% {\n    stroke-width: 3;\n    opacity: 1;\n  }\n  50% {\n    stroke-width: 4;\n    opacity: 0.9;\n  }\n}\n\n.edge-label {\n  pointer-events: none;\n  user-select: none;\n  font-weight: 500;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
